import React, { Component } from 'react'
import { Link } from 'gatsby'
import get from 'lodash/get'
import { buildURL } from '../../utils/url'
import EventTracker from '../../helpers/EventTracker'

export default class BlogWidget extends Component {
    render() {
        const { className } = this.props
        const { title, description, image, link } = this.props.data
        const backgroundImageUrl = get(image, 'file.url', null)
        const backgroundImageTitle = get(image, 'title', null)
        const internalUrl = buildURL(this.props.data)
        return (
            <div
                className={`block story-block ${className ? className : ''}`}
                onClick={() => {
                    EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.STORY_BLOCK, EventTracker.EVENT_TYPES.CLICK, 'VIEW_MORE_BUTTON')
                    window.location.href = internalUrl
                    console.log('internalUrl', internalUrl)
                }}
                style={{ cursor: 'pointer' }}
            >
                <div className="block-heading" role="img" aria-label={backgroundImageTitle} style={{ backgroundImage: `url(${backgroundImageUrl})` }} />
                <div className="block-info">
                    <div className="block-body">
                        <h4>{title}</h4>
                        <p>{get(description, 'description')}</p>
                    </div>
                    <div className="block-links">
                        <Link className="buttonLink" to={internalUrl} onClick={() => EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.STORY_BLOCK, EventTracker.EVENT_TYPES.CLICK, 'VIEW_MORE_BUTTON')}>
                            View More <i className="fa fa-arrow-right view-more-icon" />
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}
